<div class="pdf-viewer" [class.mobile]="isMobile">
  <ng-container *ngIf="!isMobile; else mobileViewer">
    <iframe [src]="signedUrl" frameborder="0"></iframe>
  </ng-container>
  <ng-template #mobileViewer>
    <p *ngIf="loadError" class="pdf-error">Unable to display the document. Please try again later.</p>
    <app-pdf-page-viewer *ngIf="pdfBlob && !loadError" [blob]="pdfBlob" [showToolbar]="true" [fileName]="fileName" (loadFailed)="onLoadFailed()"></app-pdf-page-viewer>
  </ng-template>
  <button mat-raised-button color="primary" class="close-modal-button" (click)="closeModal()">Close</button>
</div>
